<script>
import Vue from "vue";

import focusData from "../utils/focusData.js";
export default Vue.extend({
  mounted() {
    this.login();
    // debugger;
  },
  computed: {
    casePower() {
      return this.$store.state.Case.pattern;
    }
  },
  methods: {
    async login() {
      const { code, role, name } = this.$route.query;
      const originToken = this.$route.query.token;
      console.log(
        "origin🚀 ~ login ~ token, code, role:",
        originToken,
        code,
        role,
        this.$route.query
      );
      if (originToken && code && role) {
        const token = {
          role,
          code,
          name,
          token: originToken,
          type: "policy"
        };
        window.sessionStorage.setItem("token", JSON.stringify(token));
        window.sessionStorage.setItem("isCAS", true);
        sessionStorage.setItem("tokenTest", originToken);
        document.cookie = "SignInstate=true";
        sessionStorage.setItem("pageIndex", "0");
        this.$Message.success("登录成功");
        focusData.getToken();

        if (token.role === "student") {
          // this.$http.getClassMemberByCode({ id: loginData.code }).then(res2 => {
          // if (res2.data.success) {
          // sessionStorage.setItem("classId", res2.data.data.classId);
          this.$router.replace({
            path: "/Student/home"
          });
          // }
          // });
        } else if (token.role === "admin") {
          this.$router.replace({
            path: "/Teacher/userlist"
          });
        } else {
          this.$router.replace({
            path: "/Teacher/classlist"
          });
        }
      } else {
        // eslint-disable-next-line no-alert
        alert("单点登录缺少参数,即将返回登录页");
        window.location.href = "/policy/";
      }
    }
  }
});
</script>
<template lang="pug">
    Spin
        div(style="width: 99vw; height: 99vh")
</template>

<style scoped lang="stylus">
#login-box:deep(.ant-form-item-label)>label {
  color: #000000d9;
  font-size: 16px;
  font-weight: 500;
}
</style>
